import { DeviceParameters } from './Enum/DeviceParameters.ts';

export function groupArraysByProperty<T extends Record<string, any>>(
  arrays: T[][],
  property: string,
  basePlaceholder: Partial<T> = {}
): Record<string, (T | Partial<T>)[]> {
  const grouped: Record<string, (T | Partial<T>)[]> = {};

  const allKeys = new Set<string>();
  arrays.forEach((array) => {
    array.forEach((item) => {
      allKeys.add(item[property]);
    });
  });

  allKeys.forEach((key) => {
    grouped[key] = Array.from({ length: arrays.length }, () => ({
      ...basePlaceholder,
      [property]: key,
    }));
  });

  arrays.forEach((array, productIndex) => {
    array.forEach((item) => {
      const key = item[property];
      grouped[key][productIndex] = item;
    });
  });

  return grouped;
}

export const getDeviceParameterData = (): DeviceParameters => {
  if (window.innerWidth <= 767) return DeviceParameters.Mobile;

  if (window.innerWidth <= 991) return DeviceParameters.Tablet;

  return DeviceParameters.Desktop;
};

export const getSlotArray = (productCount: number) => {
  let deviceParameters = getDeviceParameterData();

  if (deviceParameters === DeviceParameters.Desktop && productCount < 4) return [1, 2, 3, 4];
  if (
    (deviceParameters === DeviceParameters.Mobile || deviceParameters === DeviceParameters.Tablet) &&
    productCount < 2
  )
    return [1, 2];

  return [];
};
